module.exports = __webpack_public_path__ + "static/girl_desktop-0e7888e3800b572374ea09f766a61655.png";